import { api, ReadAs } from './api';
import { Routes } from './_generatedTypes.g';
import { UnknownAction, Dispatch } from 'redux';
import { NavigateFunction } from 'react-router-dom';
import { innerStateSet, loadingStateSet, panicStateSet } from './features/innerState/innerStateSlice';

export const logout = async (navigate: NavigateFunction, token: string, dispatch: Dispatch<UnknownAction>) => {
    dispatch(loadingStateSet());
    return await api(token).User.Logout<void>({})
        .ok(state => {
            dispatch(innerStateSet(state));
            navigate('/');
        }, ReadAs.Json)
        .anyStatus((_, response) => {
            throw new Error(`${Routes.User.Logout} failed with status code ${response.status}`);
        })
        .fail(() => dispatch(panicStateSet()));
}
